// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X-cv","content":"styles_content__wsPVu","tableWrap":"styles_tableWrap__2cbXV"};